<template>
    <div class="int-join-ms-wrap">
        <div class="int-join-top">
            <a href="javascript:;" @click="btn_mainClick()">
                <div class="img-com join-member-logo"><span>로고</span></div>
            </a>
            <a href="#" style="position:absolute;top:52px;right:0px;" @click="btn_mainClick()">메인페이지로 이동</a>
        </div>
        <section class="int-join-ms join-stage">
            <div class="join-stage-top">
                <h1>아이디ㆍ비밀번호 찾기</h1>
            </div>
            <div class="join-stage-con">
                <div class="join-stage-tab">
                    <ul class="tabmenu">
                        <li :class="tabSe == 'id' ? 'current':''" @click="btn_tabClick('id')"><a href="javascript:;">아이디 찾기</a></li>
                        <li :class="tabSe == 'pw' ? 'current':''" @click="btn_tabClick('pw')"><a href="javascript:;">비밀번호 찾기</a></li>
                    </ul>
                    <div class="tab-container">
                        <div class="tab-content" id="tab-1" style="display:;">
                            <div class="join-find">
                                <template v-if="step == 'input'">
                                    <div class="entry-title">휴대폰번호로 아이디를 찾을 수 있습니다.</div>
                                    <div class="content-entry">
                                        <input type="radio" id="rdo01" name="rdo" checked />
                                        <label for="rdo01"><span class="box"></span>휴대폰번호로 찾기</label>
                                    </div>
                                    <!-- 휴대폰번호 -->
                                    <div class="entry-txt">가입 시 등록한
                                      <span class="pc01">성명과 휴대폰번호</span>를 입력해주세요.</div>
                                    <div class="join-stage-con mgt10">
                                        <div class="join-stage-input" v-if="tabSe == 'pw'">
                                            <input type="text" placeholder="아이디" title="아이디"
                                                   @keyup.space="spaceKeyUp('id')"
                                                   v-model="input.mberInfo.id"/>
                                        </div>
                                        <div class="join-stage-input">
                                            <input type="text" placeholder="성명" title="성명"
                                                   v-model="input.mberInfo.mberNm"/>
                                        </div>
                                        <div class="join-stage-input">
                                            <div class="join-stage-box">
                                                <select v-model="input.mberInfo.cttpc1"
                                                        :disabled="input.phoneCrtfctn.time > 0">
                                                    <option>010</option>
                                                    <option>011</option>
                                                    <option>016</option>
                                                    <option>017</option>
                                                    <option>018</option>
                                                    <option>019</option>
                                                </select>
                                                <input type="text" class="mgr10" 
                                                    v-model="input.mberInfo.cttpc2" maxlength="4"
                                                    :disabled="input.phoneCrtfctn.time > 0"
                                                    :style="{'color':input.phoneCrtfctn.time > 0?'gray':'black'}"
                                                    @keyup="$onbiLib.onlyNumberKeyup()"
                                                    @keydown="$onbiLib.onlyNumberKeydown()"/> - 
                                                <input type="text" class="mgl10"  
                                                    v-model="input.mberInfo.cttpc3" maxlength="4"
                                                    :disabled="input.phoneCrtfctn.time > 0"
                                                    :style="{'color':input.phoneCrtfctn.time > 0?'gray':'black'}"
                                                    @keyup="$onbiLib.onlyNumberKeyup()"
                                                    @keydown="$onbiLib.onlyNumberKeydown()"/>
                                            </div>
                                            <button :class="setBtnClass('btn_sendNum')"
                                                    ref="btn_sendNum"
                                                    @click="btn_crtfctnClick()">
                                              <template v-if="clickCnt == 0">인증</template>
                                              <template v-if="clickCnt > 0">재인증</template>
                                            </button>
                                        </div>
                                        <div class="join-stage-input">
                                            <input type="text" 
                                                   placeholder="인증번호 입력(3분 이내)" 
                                                   title="인증번호" ref="crtfyNum" maxlength="6"
                                                   v-model="input.mberInfo.crtfyNum"
                                                   :disabled="input.phoneCrtfctn.timer == null || input.phoneCrtfctn.time==0"
                                                   :style="{'background':input.phoneCrtfctn.timer == null||input.phoneCrtfctn.time==0?'#f8f8f8':'#fff'}"
                                                   @keyup="$onbiLib.onlyNumberKeyup()"
                                                   @keydown="$onbiLib.onlyNumberKeydown()"/>
                                            <span>{{setTimerShow}}</span>
                                            <button :class="setBtnClass('btn_crtfy')" ref="btn_crtfy"
                                                    @click="btn_cnfrmNumClick()">확인</button>
                                        </div>
                                    </div>
                                    <!-- //휴대폰번호 -->
                                    <div class="btn-wrap __btn-join">
                                        <button class="red" @click="btn_nextClick()">다음</button>
                                    </div>
                                </template>

                                <!-- 재설정 -->
                                <template v-if="step == 'reset'">
                                    <div class="box-type01">
                                        <div class="join-box" v-if="reset.mberInfo.mberNo != ''">
                                            <div class="entry-txt01 ">개인정보 보호를 위해 새로운 비밀번호를 입력해주세요.</div>
                                            <div class="join-stage-input mgt40">
                                                <input type="password" placeholder="비밀번호" title="비밀번호"
                                                        maxlength="15" ref="password"
                                                       v-model="reset.password" @keyup.space="spaceKeyUp('new')"/>
                                                <input type="password" placeholder="비밀번호 확인" title="비밀번호 확인"
                                                        maxlength="15" ref="chkPassword"
                                                       v-model="reset.chkPassword" @keyup.space="spaceKeyUp('chk')"/>
<!--                                                <button class="act" @click="btn_resetClick()">재설정</button>-->
                                            </div>
                                            <div class="entry-txt02 mgt40">8-15자리의 영문/숫자/특수문자를 함께 입력해주세요.</div>
                                        </div>
                                        <div class="join-box" v-if="reset.mberInfo.mberNo == ''">
                                            <div class="entry-txt02">입력하신 정보와 일치하는 회원이 없습니다. 정확한 정보를 입력해주세요.</div>
                                        </div>
                                    </div>
                                    <div class="btn-wrap __btn-join" v-if="reset.mberInfo.mberNo != ''">
                                        <button class="red" @click="btn_resetClick()">다음</button>
                                    </div>
                                    <div class="btn-wrap __btn-join" v-if="reset.mberInfo.mberNo == ''">
                                      <button class="red" @click="btn_tabClick('pw')">비밀번호 다시 찾기</button>
                                    </div>
                                </template>
                                <!-- //재설정 -->

                                <!-- 완료 -->
                                <template v-if="step=='comp'">
                                    <div class="box-type01">
                                        <template v-if="tabSe == 'id'">
                                            <div class="join-box" v-if="comp.mberList.length > 0">
                                                <div class="img-com __join-comp"><span>완료</span></div>
                                                    <div class="entry-txt01 mgt30">{{input.mberInfo.mberNm}}님의 아이디<br><br>
                                                        <p v-for="(mberInfo, index) in comp.mberList" :key="'mberInfo_'+index">{{mberInfo.id}}</p>
                                                    </div>
                                                    <div class="entry-txt02 mgt60">로그인 후 아이오감의 다양한 서비스를 이용하세요.</div>
                                                <template v-if="tabSe=='pw'">
                                                    <div class="entry-txt01 mgt30"><span>[{{input.mberInfo.id}}]</span>님의 비밀번호가 변경되었습니다.</div>
                                                    <div class="entry-txt02 mgt60">새로운 비밀번호로 안전하게 아이오감 서비스를 이용해주세요.</div>
                                                </template>
                                            </div>
                                            <div class="join-box" v-if="comp.mberList.length == 0">
                                                <div class="entry-txt02">입력하신 정보와 일치하는 회원이 없습니다. 정확한 정보를 입력해주세요.</div>
                                            </div>
                                        </template>
                                        <div class="join-box" v-if="tabSe == 'pw'">
                                            <div class="img-com __join-comp"><span>완료</span></div>
                                            <div class="entry-txt01 mgt30"><span>[{{input.mberInfo.id}}]</span>님의 비밀번호가 변경되었습니다.</div>
                                            <div class="entry-txt02 mgt60">새로운 비밀번호로 안전하게 아이오감 서비스를 이용해주세요.</div>
                                        </div>
                                    </div>
                                    <div class="btn-wrap __btn-join" v-if="comp.mberList.length > 0 || reset.mberInfo.mberNo != ''">
                                        <button class="red" @click="btn_loginClick()">로그인</button>
                                    </div>
                                    <div class="btn-wrap __btn-join" v-if="comp.mberList.length == 0 && tabSe == 'id'">
                                      <button class="red" @click="btn_tabClick('id')">아이디 다시 찾기</button>
                                    </div>
                                </template>
                                <!-- //완료 -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    const mixinComp = {
      computed: {
        setTimerShow: function () {
          if (this.input.phoneCrtfctn.timer == null) return '--:--';
          else {
            let min = Math.floor(this.input.phoneCrtfctn.time / 60);
            let sec = this.input.phoneCrtfctn.time % 60;
            if (sec < 10) {
              sec = '0' + sec
            }
            if (min == 0 && sec == 0) {
              return '--:--';
            }
            return min + ':' + sec;
          }
        },
      },
        data: function(){
            return {
                comp : {
                    mberList : new Array(),
                }
            }
        },
        methods : {
        }
    }

    const mixinReset = {
        data: function(){
            return {
                resetChkAt : false,
                reset : {
                    mberInfo : new Array(),
                    password : '',
                    chkPassword : '',
                },
                defResetMberInfo : {
                    mberNo : '',
                    id : '',
                }
            }
        },
        methods : {
            btn_resetClick : function(){
                if(this.reset.password == ''){
                  this.$toasted.show("변경할 비밀번호를 입력해주세요.");
                  this.$refs.password.focus();
                  return false;
                }

                if(!this.validCheck()) {
                  this.$refs.password.focus();
                  return false;
                }

                if(this.reset.password != this.reset.chkPassword){
                  this.$toasted.show("비밀번호가 일치하지 않습니다.");
                  this.$refs.chkPassword.focus();
                  return false;
                }

                this.checkPwProc().then(function(code){
                  if(code == '001'){
                    this.modifyPw();
                  }else if(code == '997'){
                    this.$toasted.show('현재 비밀번호와 동일하게 변경 불가합니다.');
                    return false;
                  }else if(code == '998'){
                    this.$toasted.show('이전 비밀번호와 동일하게 변경 불가합니다.');
                    return false;
                  }else if(code == '999'){
                    this.$toasted.show('현재 비밀번호가 일치하지 않습니다.');
                    return false;
                  }
                  }.bind(this)).catch(function (e) {
                    console.log(e);
                    this.$toasted.show(this.$onbiLib.msg.err.system);
                  }.bind(this));
            },
            modifyPw: function (){
              this.axios.post('/i5gam/member/changePwProc.act',{
                mberInfo : {
                  mberNo : this.reset.mberInfo.mberNo,
                  password : this.reset.password
                }
              }).then(function() {
                this.$toasted.show('비밀번호가 ' + this.$onbiLib.msg.suc.chng, {duration:1000, type:'success'});
                this.resetChkAt = true;
                this.step = 'comp';
              }.bind(this)).catch(function(e) {
                console.log(e);
                this.$toasted.show(this.$onbiLib.msg.err.system);
              }.bind(this));
            },
            validCheck : function(){
                if(this.reset.password.length > 0){
                    let chk = 0;
                    if(this.reset.password.search(/[0-9]/g) != -1 ) chk ++;
                    if(this.reset.password.search(/[a-z]/ig)  != -1 ) chk ++;
                    if(this.reset.password.search(/[!@#$%^&*()?_~]/g)  != -1  ) chk ++;

                    if((chk < 3) || (this.reset.password.length < 8 || this.reset.password.length > 15)){
                        this.$toasted.show("비밀번호는 영문, 숫자, 특수문자를 포함하여 8~15자로 생성해주세요.");
                        return false;
                    }
                }else{
                    this.$toasted.show("비밀번호를 입력해주세요.");
                    return false;
                }
                //같은 문자 4번 제한
                if(!this.passwdRepeatKeyChk()) return false;

                //ID포함여부 체크
                if(!this.passwdIdChk()) return false;

                //연락처 포함여부 체크
                if(!this.passwdCttpcChk()) return false;

                //연속된 문자/숫자 정규식 생성
                if(!this.passwdCntnKeyChk()) return false;

                //잘알려진단어 체크
                if(!this.passwdKnownWordChk()) return false;

                return true;
            },
            checkPwProc : function(){
                return new Promise(function(resolve, reject){
                    this.axios.post('/i5gam/member/checkPwProc.act',{
                      mberInfo : {
                        mberNo : this.reset.mberInfo.mberNo,
                        password : 'findPw',
                        newPassword : this.reset.password,
                      }
                    }).then(function(response) {
                      const code = response.data.procCode;
                      resolve(code);
                    }.bind(this)).catch(function(e) {
                      reject(e);
                    });
                }.bind(this))
            },
            passwdCttpcChk: function (){
              let cttpc = this.input.mberInfo.cttpc2 + this.input.mberInfo.cttpc3;
                if (this.reset.password.search(cttpc) > -1) {
                  this.$toasted.show("연락처가 포함된 비밀번호는 사용하실 수 없습니다.");
                  return false;
                }else return true;
            },
            passwdIdChk: function (){
                if (this.reset.password.search(this.input.mberInfo.id) > -1) {
                  this.$toasted.show("ID가 포함된 비밀번호는 사용하실 수 없습니다.");
                  return false;
                }else return true;
            },
            passwdRepeatKeyChk: function (){
              if (/(\w)\1\1\1/.test(this.reset.password)) {
                this.$toasted.show('비밀번호에 같은 문자를 4번 연속 사용하실 수 없습니다.');
                return false;
              }else return true;
            },
            passwdCntnKeyChk: function (){
              const max = 4;
              const cntnlimit = ["0123456789", "9876543210",
                "qwertyuiopasdfghjklzxcvbnm",
                "QWERTYUIOPASDFGHJKLZXCVBNM"]
              let Pattern;

              for (let i = 0; i < cntnlimit.length; i++) {
                let check1 = cntnlimit[i];
                let check2 = cntnlimit[i] + cntnlimit[i];
                for (let j = 0; j < check1.length; j++) {
                  let x = check1.substr(j, 1);
                  let y = check2.substr(j, max);
                  Pattern += "[" + x + "]{" + max + ",}|" + y + "|";
                }
              }
              Pattern = new RegExp(Pattern.replace(/.$/, ""));
              if (Pattern.test(this.reset.password)) {
                this.$toasted.show("연속된 숫자와 문자를 4번 연속 사용하실수 없습니다.");
                return false;
              }else return true;
            },
            passwdKnownWordChk: function (){
              const wordLimit = ["love", "LOVE", "happy", "HAPPY", "password", "PASSWORD"
                , "iloveyou", "ILOVEYOU", "dragon", "DRAGON", "sunshine"
                , "SUNSHINE", "princess", "PRINCESS", "letmein", "LETMEIN"
                , "monkey", "MONKEY", "superman", "SUPERMAN", "hello", "HELLO"
                , "google", "GOOGLE", "apple", "APPLE", "samsung", "SAMSUNG"]
              let msg = '';
              for (let i = 0; i < wordLimit.length; i++) {
                if (this.reset.password.search(wordLimit[i]) > -1) {
                  msg = wordLimit[i];
                }
              }
              if (msg != '') {
                this.$toasted.show("비밀번호에 [" + msg + "]를 사용하실수 없습니다.");
                return false;
              }else return true;
            },
            spaceKeyUp: function(info){
              this.$toasted.show('공백입력은 불가합니다.');
              if(info == 'new'){
                this.reset.password = this.reset.password.replace(/ /gi,'');
              }else if (info == 'chk'){
                this.reset.chkPassword = this.reset.chkPassword.replace(/ /gi,'');
              }
            },
        }
    }

    const mixinInput = {
        data: function(){
            return {
                input: {
                    mberInfo : new Array(),
                    phoneCrtfctn: {
                      timer: null,
                      time: 0,
                      cttpc1: '',
                      cttpc2: '',
                      cttpc3: '',
                    },
                },
                clickCnt:0
            }
        },
        methods : {
            btn_crtfctnClick : function(){
                if(this.setBtnClass('btn_sendNum') == 'deagi') return false;

                if(this.input.mberInfo.cttpc1 == this.input.phoneCrtfctn.cttpc1&&
                    this.input.mberInfo.cttpc2 == this.input.phoneCrtfctn.cttpc2&&
                    this.input.mberInfo.cttpc3 == this.input.phoneCrtfctn.cttpc3){
                  this.$toasted.show('이미 인증된 휴대폰번호 입니다.');
                  return false;
                }

                if(this.input.mberInfo.cttpc2 == '' || this.input.mberInfo.cttpc3.length == ''){
                    this.$toasted.show('휴대폰번호를 입력해주세요.');
                    return false;
                }

                if(this.input.mberInfo.cttpc2.search(/^\d{3,4}$/) === -1 || this.input.mberInfo.cttpc3.search(/^\d{4}$/) === -1){
                    this.$toasted.show("숫자만 입력 가능합니다.");
                    this.input.mberInfo.cttpc2 = '';
                    this.input.mberInfo.cttpc3 = '';
                    return false;
                }

                this.phoneCrtfyNumSend();
            },
            btn_cnfrmNumClick : function(){ //인증번호 확인 버튼
                if(this.setBtnClass('btn_crtfy') == 'deagi') return false;

                if(this.input.mberInfo.crtfyNum == ''){
                    this.$toasted.show('인증번호를 입력하지 않았습니다. 수신한 인증번호를 입력해주세요.');
                    return false;
                }

                if(this.input.mberInfo.crtfyNum.length != 6){
                    this.$toasted.show('인증번호를 6자리로 입력해주세요.');
                    return false;
                }

                const mberInfo = this.input.mberInfo;
                this.axios.post('/common/crtfy/phoneCrtfyNumCnfrm.act',{
                    crtfyNum: mberInfo.crtfyNum,
                    cttpc : mberInfo.cttpc1 + "-" + mberInfo.cttpc2 + "-" + mberInfo.cttpc3,
                    mberNm : mberInfo.mberNm
                }).then(function(response) {
                    const crtfyNumChkCode = response.data.crtfyNumChkCode;
                    if(crtfyNumChkCode == '001'){
                        this.input.mberInfo.chkCrtfy = true;
                        this.$toasted.show('인증번호가 일치합니다.',{duration:1000,type:"info"});
                        this.input.phoneCrtfctn.cttpc1 = this.input.mberInfo.cttpc1;
                        this.input.phoneCrtfctn.cttpc2 = this.input.mberInfo.cttpc2;
                        this.input.phoneCrtfctn.cttpc3 = this.input.mberInfo.cttpc3;
                        clearInterval(this.input.phoneCrtfctn.timer);
                        this.input.phoneCrtfctn.time = 0;
                    }else if(crtfyNumChkCode == '998'){
                        this.$toasted.show('인증번호를 발송한 휴대폰 번호와 현재 입력된 휴대폰 번호가 다릅니다.');
                    }else if(crtfyNumChkCode == '999'){
                        this.$toasted.show('인증번호가 일치하지 않습니다. 입력한 휴대폰번호와 수신한 인증번호를 다시 한번 확인해주세요.');

                        this.$refs.crtfyNum.focus();
                    }
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    this.$toasted.show(this.$onbiLib.msg.err.system);
                }.bind(this));
            },
            findMberInfo : function(){
                return new Promise(function (resolve, reject) {
                    this.axios.post('/i5gam/member/findIdPwProc.act',{
                        findInfo : this.input.mberInfo,
                        findSe : 'cttpc',
                        appName : '',
                    }).then(function(response) {
                        const mberList = response.data.mberList;
                        resolve(mberList);
                    }.bind(this)).catch(function(e) {
                        reject(e);
                    });
                }.bind(this));
            },
            phoneCrtfyNumSend : function(){ //인증번호 전송
                this.axios.post('/common/crtfy/phoneCrtfyNumSend.act',{
                    cttpc : this.input.mberInfo.cttpc1 + "-" + this.input.mberInfo.cttpc2 + "-" + this.input.mberInfo.cttpc3,
                    srvcCd : 'SBIW02'
                }).then(function(){
                    this.clickCnt += 1;
                    this.$toasted.show('인증번호를 발송했습니다. 인증번호가 오지 않으면 입력하신 정보가 정확한지 확인해주세요. 발송된 인증번호는 3분간 유효합니다.', {duraion:1000, type:"info"});
                    //3분 타이머 설정
                    this.setCrtfctnTimer();

                    this.$refs.crtfyNum.focus();
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    this.$toasted.show(this.$onbiLib.msg.err.system);
                }.bind(this));
            },
            setCrtfctnTimer : function(){   //타이머 설정
              this.input.mberInfo.chkCrtfy = false;
              this.input.mberInfo.crtfyNum = '';
              clearInterval(this.input.phoneCrtfctn.timer);

              //타이머 설정
              this.input.phoneCrtfctn.time = 180;
              this.input.phoneCrtfctn.timer = setInterval(function(){
                if(this.input.phoneCrtfctn.time == 0){
                  this.input.mberInfo.chkCrtfy = false;
                  this.input.mberInfo.crtfyNum = '';
                  this.$toasted.show('인증번호 유효시간이 만료되었습니다. 다시 인증해주세요.');
                  clearInterval(this.input.phoneCrtfctn.timer);
                }else{
                  this.input.phoneCrtfctn.time--;
                }
              }.bind(this), 1000);
            },
            setBtnClass : function(btnSe){
              let cls = 'deagi'
              if(btnSe=='btn_sendNum'){
                if(this.input.mberInfo.cttpc2.length >= 3
                    && this.input.mberInfo.cttpc3.length == 4
                    && this.input.phoneCrtfctn.time == 0) cls = 'act';
              }else if(btnSe == 'btn_crtfy'){
                if(this.input.mberInfo.crtfyNum.length == 6
                    && !this.input.mberInfo.chkCrtfy) cls = 'act';
              }
              return cls;
            },
            spaceKeyUp: function(){
              this.$toasted.show('공백입력은 불가합니다.');
              this.mberInfo.id = this.mberInfo.id.replace(/ /gi,'');
            },
        }
    }

    export default {
        name : 'findIdPw',
        mixins : [mixinInput, mixinComp, mixinReset],
        data : function(){
            return{
                tabSe : 'id',
                step : '',
                defMberInfo : {
                    mberNm : '',
                    id : '',
                    cttpc1 : '010',
                    cttpc2 : '',
                    cttpc3 : '',
                    cttpc : '',
                    crtfyNum : '',
                    chkCrtfy : false	//휴대폰 인증 체크
                },
                defPhoneCrtfctn : {
                    timer: null,
                    time: 0,
                    cttpc1: '',
                    cttpc2: '',
                    cttpc3: '',
                }
            }
        },
        methods : {
            init : function(){
                this.input.mberInfo = JSON.parse(JSON.stringify(this.defMberInfo));
                this.reset.mberInfo = JSON.parse(JSON.stringify(this.defResetMberInfo));
                this.comp.mberList = new Array();
                this.clickCnt = 0;

                this.step = 'input';
            },
            btn_tabClick : function(tabSe){
                if(this.tabSe == tabSe && this.step == 'input') return false;
                if(this.input.phoneCrtfctn.timer != null && this.input.phoneCrtfctn.time >0){
                  if(!confirm("휴대폰 인증이 취소됩니다. 취소하시겠습니까?")){
                    return false;
                  }
                }
                clearInterval(this.input.phoneCrtfctn.timer);
                this.input.phoneCrtfctn = JSON.parse(JSON.stringify(this.defPhoneCrtfctn));
                this.tabSe = tabSe;
                this.init();
            },
            btn_loginClick : function(){
                this.$router.push({ name: 'views.i5gam.index'});
            },
            btn_mainClick : function(){
                if(this.input.phoneCrtfctn.timer != null && this.input.phoneCrtfctn.time >0){
                  if(confirm("휴대폰 인증이 취소됩니다. 취소하시겠습니까?")){
                    clearInterval(this.input.phoneCrtfctn.timer);
                    this.input.phoneCrtfctn = JSON.parse(JSON.stringify(this.defPhoneCrtfctn));
                  }else {
                    return false;
                  }
                }
                this.$router.push({ name: 'views.i5gam.index'});
            },
            btn_nextClick : function(){
                if(this.step == 'input'){
                    if(!this.input.mberInfo.chkCrtfy){
                        this.$toasted.show('휴대폰번호 인증을 해주세요.');
                        return false;
                    }

                    const _this = this;
                    this.findMberInfo().then(function(mberList){
                        if(_this.tabSe == 'id'){
                            if(mberList.length > 0) _this.comp.mberList = mberList;
                            _this.step = 'comp';
                        }else{
                            if(mberList.length > 0){
                                _this.reset.mberInfo = mberList[0];
                            }else{
                                _this.reset.mberInfo = JSON.parse(JSON.stringify(_this.defResetMberInfo));
                            }

                            _this.step = 'reset';
                        }
                    });
                }else if(this.step == 'reset'){
                    this.step = 'comp';
                }

            },

        },
        mounted : function(){
            this.init();
        }
    }
</script>